import Vue from 'vue';
import notificationService from '@/services/notificationService';
import { Module } from 'vuex';
import repos from '@/services/rawmaterialsRepository';

const rawmaterialsModule: Module<any, any> = {
    namespaced: true,
    state: {
        loading: true,
        saving: false,
        initialised: false,
        items: [],
    },
    getters: {
        items: (state) => state.items,
        item: (state) => (id: string) => state.items.find((o: IRawMaterial) => o.id === id),
        loading: (state) => state.loading,
    },
    mutations: {
        setItems(state, objects) {
            state.initialised = true;
            state.items = objects;
        },
        addItem(state, object) {
            state.items.push(object);
        },
        updateItem(state, object) {
            const foundItem = state.items.find((x: any) => x.id === object.id);
            if (foundItem) {
                Object.assign(foundItem, object);
            }
        },
        removeItem(state, object) {
            const index = state.items.indexOf(object);
            if (index !== -1) {
                state.items.splice(index, 1);
            }
        },
        setLoading(state, value) {
            state.loading = value;
        },
        setSaving(state, value) {
            state.saving = value;
        },
    },
    actions: {
        async fetch({ commit, dispatch, state }) {
            if (!state.initialised) {
                await dispatch('load');
            }
        },
        async load({ commit, dispatch }) {
            commit('setLoading', true);
            try {
                const res = await repos.get();
                commit('setItems', res.data);
            } catch (err) {
                notificationService.failedToLoad();
                await dispatch('load');
            } finally {
                commit('setLoading', false);
            }
        },
        async create({ commit }, object) {
            commit('setSaving', true);
            try {
                const res = await repos.create(object);
                commit('addItem', res.data);
                notificationService.saved();
                return res.data.id;
            } catch (err) {
                notificationService.failedToSave();
                return false;
            } finally {
                commit('setSaving', false);
            }
            return true;
        },
        async copy({ commit }, id: string) {
            commit('setSaving', true);
            try {
                const res = await repos.copy(id);
                commit('addItem', res.data);
                notificationService.saved();
                return res.data.id;
            } catch (err) {
                notificationService.failedToSave();
                return false;
            } finally {
                commit('setSaving', false);
            }
        },
        async update({ commit }, object) {
            commit('setSaving', true);
            try {
                const res = await repos.update(object);
                commit('updateItem', res.data);
                notificationService.saved();
                return true;
            } catch (err) {
                notificationService.showAxiosError(err);
                return false;
            } finally {
                commit('setSaving', false);
            }
        },
        async delete({ commit }, object) {
            commit('setSaving', true);
            try {
                const res = await repos.delete(object);
                commit('removeItem', object);
                notificationService.saved();
            } catch (err) {
                notificationService.failedToSave();
                return false;
            } finally {
                commit('setSaving', false);
            }
            return true;
        },
    },
};

export default rawmaterialsModule;
